"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    href: "https://github.com/terraforming-mars/terraforming-mars/wiki/FAQ#purge",
    target: "_blank"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (_ctx.expectedPurgeTimeMs != 0)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_1, [
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(_ctx.hoursLeft < 48 ? 'general-warning' : '')
            }, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.translateTextWithParams('Warning: This game will be purged in approximately ${0} hours.', [Math.floor(_ctx.hoursLeft).toString()])), 1)
                ])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("a", _hoisted_2, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[0] || (_cache[0] = [
                            (0, vue_1.createTextVNode)("Why?", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ])
            ], 2)
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
